// extracted by mini-css-extract-plugin
export default {"title-screen":"titleScreen_title-screen__JG4JD","title":"titleScreen_title__xSRF0"};